module.exports = __webpack_public_path__ + "static/media/404-page-not-found.2c65ec36.png";